import { CircularProgress, FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import { includes } from "lodash";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import loadProperty from "../property/ducks/actions";
import propertyOperations from "../property/ducks/operations";
import operations from "./ducks/operations";
import ResearchSnapshot from "./ResearchSnapshot";
import TrackResearchModal from "./TrackResearchModal";

const StyledRsContainer = styled("div")({
    marginBottom: "20px",
});

const StyledAlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "3em",
    marginBottom: "3em",
    color: "rgba(0, 0, 0, 0.30)",
    fontSize: "20px",
});

const StyledAlternateContentRed = styled("div")(({ theme }) => ({
    margin: "auto",
    textAlign: "center",
    marginTop: "3em",
    marginBottom: "3em",
    color: theme.palette.error.dark,
    fontSize: "20px",
}));

const StyledPaperHeading = styled("h3")({
    fontSize: "18px",
    margin: "14px 0 2px 0",
});

const StyledLoadWheel = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
    marginTop: "15px",
});

const ResearchTab = (props) => {
    const [data, setData] = useState(null);
    const [newProperty, setNewProperty] = useState("");
    const [awaitingTrack, setAwaitingTrack] = useState(false);
    const [trackModalOpen, setTrackModalOpen] = useState(false);

    const { role, propertyKey, loadProperty, property } = props;

    const loadData = async () => {
        const data = await operations.getResearchByProperty(propertyKey);
        setData(data);
    };

    useEffect(() => {
        loadData();
        setNewProperty(property);
    }, []);

    const changeTracked = async () => {
        setNewProperty((prev) => ({
            ...property,
            trackedFlg: !prev.trackedFlg,
        }));
        setAwaitingTrack(true);
        const response = await propertyOperations.handleSubmitPropertyForm(true, newProperty, null);
        loadProperty(response.data);
        setAwaitingTrack(false);
    };

    const handleOpenTrackModal = () => {
        setTrackModalOpen(true);
    };

    const handleCloseTrackModal = () => {
        setTrackModalOpen(false);
    };

    return (
        <div>
            {data != null ? (
                <div>
                    {data === "error" ? (
                        <StyledAlternateContentRed>
                            A connection error occurred. Please refresh the page.
                        </StyledAlternateContentRed>
                    ) : (
                        <div>
                            <div style={{ display: "inline-block", width: "100%" }}>
                                <div style={{ float: "left" }}>
                                    <StyledPaperHeading>Research</StyledPaperHeading>
                                    <p className="page-subtitle" style={{ marginBottom: "16px" }}>{`SHOWING ${
                                        data.length
                                    } ${data.length === 1 ? "ENTRY" : "ENTRIES"} `}</p>
                                </div>
                                {includes(["research", "researchAdmin", "dataAdmin", "dataEntry"], role) ? (
                                    <div style={{ float: "right", marginTop: "12px" }}>
                                        {awaitingTrack === false ? (
                                            <div>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={newProperty.trackedFlg === true ? true : false}
                                                            onChange={() => handleOpenTrackModal()}
                                                            color="primary"
                                                            disabled={includes(["dataEntry"], role)}
                                                        />
                                                    }
                                                    label="Tracked"
                                                />
                                                <TrackResearchModal
                                                    modalOpen={trackModalOpen}
                                                    closeModal={handleCloseTrackModal}
                                                    confirm={changeTracked}
                                                    trackedValue={newProperty.trackedFlg}
                                                />
                                            </div>
                                        ) : (
                                            <StyledLoadWheel>
                                                <CircularProgress size={20} />
                                            </StyledLoadWheel>
                                        )}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            {data.length > 0 ? (
                                <div>
                                    {
                                        <StyledRsContainer>
                                            <ResearchSnapshot {...props} snapshot={data} />
                                        </StyledRsContainer>
                                    }
                                </div>
                            ) : (
                                <StyledAlternateContent>
                                    No Research Snapshots exist for this property.
                                </StyledAlternateContent>
                            )}
                        </div>
                    )}
                </div>
            ) : (
                <StyledAlternateContent>
                    <CircularProgress />
                </StyledAlternateContent>
            )}
        </div>
    );
};

export default connect(null, loadProperty)(ResearchTab);
